import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { styled } from "@mui/system";
import API from "../../api";
import { removeAuth } from "../../utils/auth";

const Container = styled(Box)({
  padding: 16,
  backgroundColor: "#f5f5f5",
  minHeight: "100vh",
});
const Content = styled(Paper)({ padding: 16, maxWidth: 800, margin: "auto" });

export default function EarningsPage() {
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(0);
  const [txns, setTxns] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const [sRes, tRes] = await Promise.all([
          API.get("/superadmin/commissions/summary"),
          API.get("/superadmin/commissions/transactions"),
        ]);
        setSummary(sRes.data.total);
        setTxns(tRes.data);
      } catch (err) {
        if (err.response?.status === 401) {
          removeAuth();
          window.location.href = "/login";
        }
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container>
      <Content elevation={4}>
        <Typography variant="h5" gutterBottom>
          Your Earnings
        </Typography>
        <Typography variant="h6" gutterBottom>
          Total Commission Earned: ₹{summary.toFixed(2)}
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Project</TableCell>
              <TableCell>Amount (₹)</TableCell>
              <TableCell>Commission (%)</TableCell>
              <TableCell>Commission Earned (₹)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {txns.map((tx) => (
              <TableRow key={tx._id}>
                <TableCell>{new Date(tx.createdAt).toLocaleString()}</TableCell>
                <TableCell>{tx.project.companyName}</TableCell>
                <TableCell>{tx.planAmount}</TableCell>
                <TableCell>{tx.commissionPercent}%</TableCell>
                <TableCell>{tx.commissionAmount.toFixed(2)}</TableCell>
              </TableRow>
            ))}
            {txns.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No commission transactions yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Content>
    </Container>
  );
}
